export class CancelAllConnectAction {
    constructor() {
        this.name = 'CancelAllConnect';
        this.isDeviceAction = false;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2FuY2VsQWxsQ29ubmVjdEFjdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvbW9kZWxzL2FjdGlvbnMvQ2FuY2VsQWxsQ29ubmVjdEFjdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLQSxNQUFNLE9BQU8sc0JBQXNCO0lBQW5DO1FBQ2tCLFNBQUksR0FBRyxrQkFBa0IsQ0FBQztRQUMxQixtQkFBYyxHQUFHLEtBQUssQ0FBQztJQUN6QyxDQUFDO0NBQUEifQ==